import React from "react";
import FocusVideo from "./videoPlayer";
import BataclanAttackVid from './images/BataclanAttack/BATACLAN-ATTACK.mp4'
import BataclanAttack1 from './images/BataclanAttack/BATACLAN_ATTACK_001 copy Large.jpeg';
import BataclanAttack2 from './images/BataclanAttack/BATACLAN_ATTACK_002 copy Large.jpeg';
import BataclanAttack3 from './images/BataclanAttack/BATACLAN_ATTACK_003 copy Large.jpeg';
import BataclanAttack4 from './images/BataclanAttack/BATACLAN_ATTACK_004 copy Large.jpeg';
import BataclanAttack5 from './images/BataclanAttack/BATACLAN_ATTACK_005 copy Large.jpeg';
import BataclanAttack6 from './images/BataclanAttack/BATACLAN_ATTACK_006 copy Large.jpeg';
import BataclanAttack7 from './images/BataclanAttack/BATACLAN_ATTACK_007 copy Large.jpeg';
import BataclanAttack8 from './images/BataclanAttack/BATACLAN_ATTACK_008 copy Large.jpeg';
import BataclanAttack9 from './images/BataclanAttack/BATACLAN_ATTACK_009 copy Large.jpeg';
import BataclanAttack10 from './images/BataclanAttack/BATACLAN_ATTACK_010 Large.jpeg';

const BataclanAttack = () => {
    return (
    <div className="picture-gallery">
        <div className="photo-column">
            <div className="single portrait fs-height">
                <img src={BataclanAttack1}/>
            </div>
            <div className="single portrait fs-height">
                <img src={BataclanAttack2}/>
            </div>
            <div className="single portrait fs-height">
                <img src={BataclanAttack3}/>
            </div>
            <div className="single portrait fs-height">
                <img src={BataclanAttack4}/>
            </div>
            <div className="single portrait fs-height">
                <img src={BataclanAttack5}/>
            </div>
            <div className="single portrait fs-height">
                <img src={BataclanAttack6}/>
            </div>
            <div className="single portrait fs-height">
                <img src={BataclanAttack7}/>
            </div>
            <div className="single portrait fs-height">
                <img src={BataclanAttack8}/>
            </div>
            <div className="single portrait fs-height">
                <img src={BataclanAttack9}/>
            </div>
            <div className="single portrait fs-height">
                <img src={BataclanAttack10}/>
            </div>
            <FocusVideo src={BataclanAttackVid} />
        </div>
    </div>
    );
}

export default BataclanAttack;